import {
  DATASTRATEGY,
  IEntity,
  STORAGESTRATEGY,
} from '@proximus/entity-manager';
import { Line } from './models/line.model';

export const lineEntity: IEntity<Line> = {
  version: 'v1',
  url: '/rest/network-device/lines/{circuitId}',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 60_000,
};

export const ontEntity: IEntity<void> = {
  version: 'v1',
  url: '/rest/network-device/lines/{circuitId}/devices/{ncName}',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 60_000,
};

export const vlanEntity: IEntity<void> = {
  version: 'v1',
  url: '/rest/network-device/lines/{circuitId}/vlanMode',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 60_000,
};

export const voipEntity: IEntity<void> = {
  version: 'v1',
  url: '/rest/network-device/voipCredentials/{subscriberNumber}',
  dataStrategy: DATASTRATEGY.PROXY_STORAGE,
  storageStrategy: STORAGESTRATEGY.NONE,
  timeout: 60_000,
};
